type EnvironmentVariables = {
  BUILD_ID?: string;
  ENVIRONMENT_NAME?: string;
  ENABLE_CI_PORT_MODIFIER?: string;
  CUSTOM_API_PORT?: string;
  ENABLE_SENTRY?: string;
  SENTRY_DSN?: string;
  DATADOG_CLIENT_TOKEN?: string;
  ENABLE_DATADOG?: string;
  ENABLE_HEAP?: string;
  HEAP_APP_ID?: string;
  ENABLE_ANALYTICS?: string;
  ENABLE_SMARTLOOK?: string;
  SMARTLOOK_PROJECT_KEY?: string;
  POS_SERVICE_TOKEN?: string;
  BENTOBOX_MACHINE_TOKEN?: string;
  CLOVER_PLATFORM_PUBLIC_KEY?: string;
  CLOVER_PAYMENT_FORM_URL?: string;
  POS_SERVICE_ROOT?: string;
};

export const getEnvironmentVariables = (): EnvironmentVariables => ({
  BUILD_ID: process.env.BUILD_ID,
  ENVIRONMENT_NAME: process.env.ENVIRONMENT_NAME,
  ENABLE_CI_PORT_MODIFIER: process.env.ENABLE_CI_PORT_MODIFIER,
  CUSTOM_API_PORT: process.env.CUSTOM_API_PORT,
  ENABLE_SENTRY: process.env.ENABLE_SENTRY,
  SENTRY_DSN: process.env.SENTRY_DSN,
  DATADOG_CLIENT_TOKEN: process.env.DATADOG_CLIENT_TOKEN,
  ENABLE_DATADOG: process.env.ENABLE_DATADOG,
  ENABLE_HEAP: process.env.ENABLE_HEAP,
  HEAP_APP_ID: process.env.HEAP_APP_ID,
  ENABLE_ANALYTICS: process.env.ENABLE_ANALYTICS,
  ENABLE_SMARTLOOK: process.env.ENABLE_SMARTLOOK,
  SMARTLOOK_PROJECT_KEY: process.env.SMARTLOOK_PROJECT_KEY,
  POS_SERVICE_TOKEN: process.env.POS_SERVICE_TOKEN,
  BENTOBOX_MACHINE_TOKEN: process.env.BENTOBOX_MACHINE_TOKEN,
  CLOVER_PLATFORM_PUBLIC_KEY: process.env.CLOVER_PLATFORM_PUBLIC_KEY,
  CLOVER_PAYMENT_FORM_URL: process.env.CLOVER_PAYMENT_FORM_URL,
  POS_SERVICE_ROOT: process.env.POS_SERVICE_ROOT
});

export const getEnvironmentName = (): string | null => {
  const { ENVIRONMENT_NAME = null } = getEnvironmentVariables();
  return ENVIRONMENT_NAME;
};
